/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

import { BEM } from "@adapptio/lib-components";
import { isFunction } from "@adapptio/lib-shared";

export interface IBreadcrumbsItemProps {
	onClick?: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
	className?: string;
	disabled?: boolean;
	tooltip?: string;
	fullWidth?: boolean;
}

export const BreadcrumbsItem: React.FC<IBreadcrumbsItemProps> = React.memo<IBreadcrumbsItemProps>(
	({ children, className, onClick, disabled, tooltip, fullWidth }) => {
		const baseClass = BEM("edt-breadcrumbs-item", null, {
			disabled,
			clickable: !!onClick,
			"full-width": fullWidth
		});

		const handleOnClick = React.useCallback(
			(event: React.SyntheticEvent<HTMLButtonElement>) => {
				event.stopPropagation();

				if (isFunction(onClick)) {
					onClick(event);
				}
			},
			[ onClick ]
		);

		return (
			<button
				className={`${baseClass.toClassName()} ${className || ""}`}
				onClick={handleOnClick}
				title={tooltip}
			>
				{children}
			</button>
		);
	}
);

BreadcrumbsItem.displayName = "BreadcrumbsItem";
